/**
 * "2026-10-11" for a GraphQL date field. Entity timestamps arrive as epoch
 * milliseconds in a string, which `new Date(string)` can't parse.
 */
export const formatDate = (value?: string | null): string => {
  if (!value) {
    return "";
  }
  const date = /^\d+$/.test(value) ? new Date(Number(value)) : new Date(value);
  return isNaN(date.getTime()) ? "" : date.toLocaleDateString("en-CA");
};
